
// // src/AdminPage.js (example)
// import React from "react";
// import AddTopicForm from "./AddTopicForm";
// import QuestionTable from "./QuestionTable";

// export default function AdminPage() {
//   return (
//     <div className="container py-3">
//       <AddTopicForm />
//       <QuestionTable />
//     </div>
//   );
// }

// src/AdminPage.js
import React, { useState } from "react";
import AddTopicForm from "./AddTopicForm";
import QuestionTable from "./QuestionTable";

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState("add");

  return (
    <div className="container py-3">
      <h2 className="h4 mb-3">Interview Admin</h2>

      {/* Tabs */}
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "table" ? "active" : ""}`}
            onClick={() => setActiveTab("table")}
            type="button"
          >
            Manage Questions (Table)
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "add" ? "active" : ""}`}
            onClick={() => setActiveTab("add")}
            type="button"
          >
            Add Topic / Question
          </button>
        </li>
        
      </ul>

      {/* Tab content */}
      <div className="tab-content mt-3">
        
        <div className={`tab-pane fade ${activeTab === "table" ? "show active" : ""}`}>
          <QuestionTable />
        </div>
        <div className={`tab-pane fade ${activeTab === "add" ? "show active" : ""}`}>
          <AddTopicForm />
        </div>
      </div>
    </div>
  );
}
